<template>
  <div class="spinner-box">
    <p v-if="!!label" class="checkbox-label">{{ label }} <span v-if="!!price">({{ price }})</span></p>
    <div class="qty-box" :key="index">
      <div
        class="qty-minus"
        @click="enableMin && change(index, 'decrease')"
        :class="(quantity == 0) ? 'disabled' : ''"
      >
        <i class="fal fa-minus"></i>
      </div>
      <div class="qty-qty">{{ quantity }}</div>
      <div
        class="qty-plus"
        @click="enableMax && change(index, 'increase')"
        :class="(quantity == max) ? 'disabled' : ''"
      >
        <i class="fal fa-plus"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    data() {
      return{
        enableMin: false,
        enableMax: true,
      }
    },
    props: {
      index: {},
      quantity: { default: 0 },
      min: { default: 0 },
      max: { default: undefined },
      label: { default: "" },
      price: { default: "" }
    },
    methods: {
      change(currentIndex, type = 'decrease'){
        let currentQuantity = this.quantity;

        if (currentQuantity > 0 && type == 'decrease') {
          currentQuantity--;
        } else {
          currentQuantity++;
        }

        this.$emit('handleItemQuantity', currentIndex, currentQuantity)
      },
    },
    created () {
      if (typeof this.tabActived == 'number') {
        this.tabActive = this.tabs[this.tabActived].name
      }
    },
    watch: {
      quantity: function(newVal) {
        this.enableMin = (this.min === undefined || newVal > this.min);
        this.enableMax = (this.max === undefined || newVal < this.max);
      },
      max: function(newVal) {
        this.max = newVal;
        this.enableMax = (this.quantity < newVal);
      }
    },
    mounted() {
      this.enableMin = (this.min === undefined || this.quantity > this.min);
      this.enableMax = (this.max === undefined || this.quantity < this.max);
    },
}
</script>
<style scoped>
  .spinner-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .qty-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-right: 3px;
    font-size: 1.4em;
    color: #CCCCCCCC;
  }

  .qty-plus,
  .qty-minus {
    background: #8C8C8C21;
    color: #D9D9D9;
    width: 22px;
    height: 22px;
    display: flex;
    font-size: 10px;
    border-radius: 5px;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }

  .qty-plus.disabled,
  .qty-minus.disabled {
    opacity: 0;
    cursor: default;
  }

  .qty-qty {
    margin: 0 10px;
  }

  .checkbox-label {
    font-size: 1.2em;
    color: #999;
  }
</style>